import HOCEditorUploadPlaceholder from './HOCEditorUploadPlaceholder';
import HOCEditorPaste from './HOCEditorPaste';
import WrappedContent from './WrappedContent';
import HOCEditorExtend from './HOCEditorExtend';
import HOCUploadAttachmentWithFiles from '../UploadAttachment/HOCUploadAttachmentWithFiles';
export default HOCUploadAttachmentWithFiles(HOCEditorUploadPlaceholder(HOCEditorPaste(HOCEditorExtend(WrappedContent))));
